import axios from 'axios';
import qs from 'qs';
import * as actionType from './constants';
import { localhost as host } from '../../host';
import { setErrorMessage, setSuccessMessage } from '../../messages/actions';
import { saveState, removeState } from '../../containers/localStorage';
import { clearScheduledJob } from '../../synchronization/actions';

const loginRequestAction = () => ({
  type: actionType.LOGIN_REQUEST
});
const loginSuccessAction = payload => ({
  type: actionType.LOGIN_SUCCESS,
  payload
});
const loginRejectAction = () => ({
  type: actionType.LOGIN_REJECT
});
const registerRequestAction = () => ({
  type: actionType.REGISTER_REQUEST
});
const registerSuccessAction = () => ({
  type: actionType.REGISTER_SUCCESS
});
const registerRejectAction = () => ({
  type: actionType.REGISTER_REJECT
});
const confirmEmailRequestAction = () => ({
  type: actionType.CONFIRM_EMAIL_REQUEST
});

const confirmEmailSuccessAction = () => ({
  type: actionType.CONFIRM_EMAIL_SUCCESS
});

const confirmEmailRejectAction = () => ({
  type: actionType.CONFIRM_EMAIL_REJECT
});

export const login = cred => {
  return dispatch => {
    dispatch(loginRequestAction());
    return axios
      .post('/login', cred)
      .then(response => {
        if (
          response.data.isBanned &&
          !response.data.rolesList.find(r => r === 'HotelAdmin')
        ) {
          dispatch(
            setErrorMessage(
              'Twoje konto zostało zablokowane. Skontaktuj się z właścicielem hotelu'
            )
          );
          dispatch(loginRejectAction());
          return;
        }

        axios.defaults.headers.common['authorization'] = `Bearer ${
          response.data.token
        }`;
        dispatch(loginSuccessAction(response.data));
        saveState('account', response.data);
      })
      .catch(err => {
        dispatch(loginRejectAction());
        dispatch(
          setErrorMessage(err.response ? err.response.data : err.toString())
        );
      });
  };
};

export const register = cred => {
  cred.callbackUrl = host + '/confirmemail';

  return dispatch => {
    dispatch(registerRequestAction());
    return axios
      .post('/register', cred)
      .then(response => {
        dispatch(registerSuccessAction());
        dispatch(setSuccessMessage('register:successMessage'));
      })
      .catch(err => {
        dispatch(registerRejectAction());
        dispatch(
          setErrorMessage(err.response ? err.response.data : err.toString())
        );
      });
  };
};

export const confirmAccount = query => {
  return dispatch => {
    dispatch(confirmEmailRequestAction());
    return axios
      .get('/confirmemail' + query)
      .then(response => {
        dispatch(confirmEmailSuccessAction());
      })
      .catch(err => {
        dispatch(confirmEmailRejectAction());
        dispatch(setErrorMessage(err.toString()));
      });
  };
};

export const changePassword = credentials => {
  return (dispatch, getState) => {
    const { userId } = getState().account.user;
    dispatch({
      type: actionType.CHANGE_PASSWORD_REQUEST
    });
    credentials.userId = userId;
    return axios
      .post('/changepassword', credentials)
      .then(response => {
        dispatch({
          type: actionType.CHANGE_PASSWORD_SUCCESS
        });
        dispatch(setSuccessMessage('resetPassword:successMessage'));
        dispatch(logout());
      })
      .catch(err => {
        dispatch({
          type: actionType.CHANGE_PASSWORD_REJECT
        });
        dispatch(setErrorMessage(err.response.data));
      });
  };
};

export const logout = () => {
  return dispatch => {
    removeState('account');
    removeState('hotels');
    removeState('selectedHotel');

    dispatch(clearScheduledJob());
    dispatch({
      type: actionType.USER_LOGOUT
    });
  };
};

export const forgotPassword = email => {
  return dispatch => {
    dispatch({ type: actionType.FORGOT_PASSWORD_REQUEST });
    return axios
      .post('/forgotpassword', { email, callbackUrl: host + '/resetpassword' })
      .then(response => {
        dispatch({ type: actionType.FORGOT_PASSWORD_SUCCESS });
        dispatch(setSuccessMessage('forgotpassword:successMessage'));
      })
      .catch(err => {
        const { response } = err;
        dispatch({ type: actionType.FORGOT_PASSWORD_REJECT });
        dispatch(setErrorMessage(response ? response.data : err.toString()));
      });
  };
};

export const resetPassword = user => {
  return dispatch => {
    dispatch({ type: actionType.RESET_PASSWORD_REQUEST });
    return axios
      .post('/resetpassword', user)
      .then(response => {
        dispatch({ type: actionType.RESET_PASSWORD_SUCCESS });
        dispatch(setSuccessMessage('login:changePasswordSuccess'));
      })
      .catch(err => {
        const { response } = err;
        dispatch({ type: actionType.RESET_PASSWORD_REJECT });
        dispatch(setErrorMessage(response ? response.data : err.toString()));
      });
  };
};

export const validateUser = () => {
  return (dispatch, getState) => {
    const { user } = getState().account;
    if (!user) {
      dispatch(logout());
      return;
    }
    return axios.get('/user/' + user.userId).then(response => {
      if (response.data !== '' && response.data != undefined) {
        dispatch({
          type: actionType.VALIDATE_USER_SUCCESS
        });
      } else {
        dispatch({
          type: actionType.VALUDATE_USER_FAILED
        });
        dispatch(logout());
      }
    });
  };
};

export const loginAs = (query, cb) => dispatch => {
  const params = qs.parse(query, { ignoreQueryPrefix: true });
  return axios
    .post(
      '/users/log-as',
      { email: params.email },
      {
        headers: {
          authorization: `Bearer ${params.token}`
        }
      }
    )
    .then(response => {
      axios.defaults.headers.common['authorization'] = `Bearer ${
        response.data.token
      }`;
      dispatch(loginSuccessAction(response.data));
      cb();
    })
    .catch(err => console.log(err));
};



// WEBPACK FOOTER //
// ./src/users/loggedUser/actions.js